import {FieldSchema} from '../types';
import identity from 'lodash/identity';

export default <V extends object>(
    data: V[],
    schema: FieldSchema[],
    order: {by?: keyof V, descending?: boolean}
) => {
    const byField = schema.find((f) => f.name === order.by);
    const format = (byField && byField.format) || identity;
    const compare = (a: V, b: V) => (
        format(a[order.by]) > format(b[order.by]) ?
            1 :
        format(a[order.by]) < format(b[order.by]) ?
            -1 :
        0
    ) * (order.descending ? -1 : 1);
    return data.sort(compare);
};
